import EventsService from "./events";
import TrainingService from "./training";
import DashboardService from "./dashboard";

export default { 
    ...EventsService,
    ...TrainingService,
    ...DashboardService,
 };